import * as React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Flippy, { FrontSide, BackSide } from "react-flippy";

import solvente from "../resources/images/solvente.png";
import formulario from "../resources/images/formulario.png";
import vestimenta from "../resources/images/vestimenta.png";
import fondo from "../resources/images/fondo.png";
import fotografia from "../resources/images/fotografia.png";
import qr from "../resources/images/qr.png";

export const HomePage = () => (
  <>
    <Header />
    <Hero />

    <div className="container">
      <div className="row">
        <div className="col text-center mb-5 mt-5">
          <p className="text-orange title-light">PASOS DE</p>
          <p className="text-orange title-bold">CARNETIZACIÓN EN LÍNEA</p>
        </div>
      </div>
      <div className="row mt-5 mb-5">
        <div className="col-6 col-md-2 mb-4 d-flex align-items-center justify-content-center">
          <Flippy
            flipOnHover={true}
            flipDirection="vertical"
            flipOnClick={true}
            className="flip"
            style={{ width: "200px", height: "220px" }}
          >
            <FrontSide className="cuadro1">
              <img src={solvente} className="iconoCard" alt="" />
              <div className="futuraBold tituloCard">DEBES ESTAR SOLVENTE</div>
            </FrontSide>
            <BackSide className="backSide">
              <div className="textoBackSide">
                Debes estar inscrito en el ciclo actual y haber cancelado el
                costo de inscripci&oacute;n.
              </div>
            </BackSide>
          </Flippy>
        </div>
        <div className="col-6 col-md-2 mb-4 d-flex align-items-center justify-content-center">
          <Flippy
            flipOnHover={true}
            flipDirection="vertical"
            flipOnClick={true}
            style={{ width: "200px", height: "220px" }}
          >
            <FrontSide className="cuadro2">
              <img src={formulario} className="iconoCard" alt="" />
              <div className="futuraBold tituloCard">
                COMPLETA EL FORMULARIO
              </div>
            </FrontSide>
            <BackSide className="backSide">
              <div className="textoBackSide">
                Inicia el tr&aacute;mite completando el Formulario de
                Carnetizaci&oacute;n en L&iacute;nea.
              </div>
            </BackSide>
          </Flippy>
        </div>
        <div className="col-6 col-md-2 mb-4 d-flex align-items-center justify-content-center">
          <Flippy
            flipOnHover={true}
            flipDirection="vertical"
            flipOnClick={true}
            style={{ width: "200px", height: "220px" }}
          >
            <FrontSide className="cuadro1">
              <img src={vestimenta} className="iconoCard" alt="" />
              <div className="futuraBold tituloCard">V&iacute;STETE FORMAL</div>
            </FrontSide>
            <BackSide className="backSide">
              <div className="textoBackSide font12">
                Al momento de tomar la fotograf&iacute;a, debe ser sin lentes y
                sin gorra, debe mostrarse tu rostro completo; en caso tengas el
                cabello largo, rec&oacute;getelo.
              </div>
            </BackSide>
          </Flippy>
        </div>
        <div className="col-6 col-md-2 mb-4 d-flex align-items-center justify-content-center">
          <Flippy
            flipOnHover={true}
            flipDirection="vertical"
            flipOnClick={true}
            style={{ width: "200px", height: "220px" }}
          >
            <FrontSide className="cuadro2">
              <img src={fondo} className="iconoCard" alt="" />
              <div className="futuraBold tituloCard">
                UTILIZA UN FONDO BLANCO
              </div>
            </FrontSide>
            <BackSide className="backSide">
              <div className="textoBackSide">
                Col&oacute;cate delante de un fondo blanco.
              </div>
            </BackSide>
          </Flippy>
        </div>
        <div className="col-6 col-md-2 mb-4 d-flex align-items-center justify-content-center">
          <Flippy
            flipOnHover={true}
            flipDirection="vertical"
            flipOnClick={true}
            style={{ width: "200px", height: "220px" }}
          >
            <FrontSide className="cuadro1">
              <img src={fotografia} className="iconoCard" alt="" />
              <div className="futuraBold tituloCard">
                VALIDACI&Oacute;N DE FOTOGRAF&Iacute;A
              </div>
            </FrontSide>
            <BackSide className="backSide">
              <div className="textoBackSide font12">
                Se validar&aacute; si tu fotograf&iacute;a cumple con los
                criterios de aceptaci&oacute;n; en caso sea rechazada,
                recibir&aacute;s un correo con las observaciones.
              </div>
            </BackSide>
          </Flippy>
        </div>
        <div className="col-6 col-md-2 mb-4 d-flex align-items-center justify-content-center">
          <Flippy
            flipOnHover={true}
            flipDirection="vertical"
            flipOnClick={true}
            style={{ width: "200px", height: "220px" }}
          >
            <FrontSide className="cuadro2">
              <img src={qr} className="iconoCard" alt="" />
              <div className="futuraBold tituloCard">ACCEDE A TU CARNÉ</div>
            </FrontSide>
            <BackSide className="backSide">
              <div className="textoBackSide">
                Al finalizar el proceso, recibir&aacute;s un correo con el
                enlace desde el cual podr&aacute;s acceder a tu carn&eacute;
                digital.
              </div>
            </BackSide>
          </Flippy>
        </div>
      </div>
      <div className="row wrap-list mt-5 pt-5">
        <div className="col-md-6 beneficios">
          <div className="title mb-5">
            <p className="text-orange title-light">BENEFICIOS DEL</p>
            <p className="text-orange title-bold">CARNÉ UFG</p>
          </div>
          <ul className="list">
            <ol>
              <li>Acredita a la persona como miembro de la UFG.</li>
              <li>
                Préstamo de material bibliográfico, soportes audiovisuales,
                herramientas en los Centros de Prática y demás servicios que
                requieran la identificación como Estudiante UFG.
              </li>
              <li>Realizar trámites académicos.</li>
              <li>Uso de plataformas digitales y estacionamiento.</li>
              <li>Ingreso a diferentes espacios de la Universidad.</li>
              <li>Descuentos con comercios afiliados de la UFG.</li>
            </ol>
          </ul>
        </div>
        <div className="col-md-6">
          <div className="title mb-5">
            <p className="text-orange title-light">CONDICIONES</p>
            <p className="text-orange title-bold">DE USO</p>
          </div>
          <ul className="list">
            <ol>
              <li>El carné es personal e intransferible.</li>
              <li>
                Presenta el carné cuando sea necesario, todas las acciones
                realizadas con el carné se entienden como efectuadas por su
                titular, por lo que es responsabilidad del titular resguardar su
                información personal.
              </li>
              <li>
                El titular del carné es responsable de informar de manera
                inmediata el hurto o pérdida de su información de carné virtual,
                de modo que sea desactivado, y evitar el mal uso de este.
              </li>
            </ol>
          </ul>
        </div>
      </div>
    </div>
    <div className="mt-5">
      <div className="container">
        <div className="row">
          <div className="col text-center">
            <Link
              to="./login"
              className="boton bg-darkblue font-futura-b text-uppercase ps-5 pe-5"
              style={{ fontSize: "1.5rem", width: "300px" }}
            >
              Ver Carnet
            </Link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </>
);
